enum EppoFlags {
  SmokeTestFF = 'EzManage::SmokeTestFF',
  SmokeTestExperiment = 'EzManage::SmokeTestExperiment',
  SelfServePromoTool = 'EzManage::SelfServePromoTool',
  OnboardingNetNewSingleLocation = 'GuidedOnboarding::NetNewSingleLocation',
  PromosReportingDashboard = 'SupplierMarketing::PromosReportingDashboard',
  CustomerEngagementChart = 'SupplierMarketing::CustomerEngagementChart',
  RockstarConvertsToRolling90Days = 'FX::RockstarConvertsToRolling90Days',
  DisallowItemDescriptionOnBrandIDs = 'EzManage::DisallowItemDescriptionOnBrandIDs',
  DisplayItemDescription = 'EzManage::DisplayItemDescription',
  RockstarPreview = 'FX::RockstarPreview',
  TurnOffIntegrationsPermission = 'EzManage::TurnOffIntegrationsPermission',
  PerformanceMetrics = 'SupplierMarketing::PerformanceMetrics',
  PerformanceMetricsCompareTo = 'SupplierMarketing::PerformanceMetricsCompareTo',
  ReadFromOrdersSdkForOrderDetails = 'SupplierSelfService::ReadFromOrdersSdkForOrderDetails',
  SponsoredPromoDetails = 'SupplierMarketing::SponsoredPromoDetails',
  DirectOnboarding = 'SupplierSelfService::DirectOnboarding',
  DirectOnboardingCopyFunctionaility = 'SupplierSelfService::DirectOnboardingCopyFunctionaility',
  AdTargetingEngagementStatus = 'SupplierMarketing::AdTargetingEngagementStatus',
  PaymentDetailsImprovements = 'SupplierMarketing::PaymentDetailsImprovements',
  OrderAttributionDrawer = 'SupplierMarketing::OrderAttributionDrawer',
  RebrandMajor = 'EzManage::2026Rebrand',
  EnableCancellationPolicyUI = 'FX::EnableCancellationPolicyUI',
}

export default EppoFlags;
